export default __webpack_public_path__ + "static/media/operations.c3d0ecff.svg";